import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_FLEET_PLANNING_URL

export const transition = async (fleetTaskId, data) => {
  const response = await apiClientV2({
    method: 'POST',
    baseURL,
    url: `/fleet-task/${fleetTaskId}/transition`,
    data,
  })

  return response?.data
}

export const bulkTransition = async (data) => {
  const response = await apiClientV2({
    method: 'POST',
    baseURL,
    url: `/fleet-task/transition`,
    data,
  })

  return response?.data
}
